/**
 * Similar to Promise.all, but executes promises in series rather than in
 * parallel.
 *
 * Accepts an array of functions that may return a value or a promise, and
 * returns an array consisting of each returned and/or resolved value. Pairs
 * well with other functors like map.
 *
 * @example
 *
 * chain([1, 2, 3].map(value => () => {
 *   // Do something with each 'value' and  return a promise or a value.
 * }))
 * .then(function (results) {
 *   // Get results here.
 * });
 *
 * @example
 *
 * chain([promiseFnA, promiseFnB, promiseFnC])
 * .then(function (results) {
 *   // Get results here.
 * });
 *
 * @param  {function[]} source - Array of functions.
 * @return {promise.<array>} - Result array.
 */
function chain(source = []) {
  return source.reduce((acc, cur) => {
    return acc.then(dest => {
      return Promise.resolve(cur()).then(result => dest.concat(result));
    });
  }, Promise.resolve([]));
}


export default chain;



// WEBPACK FOOTER //
// ./src/lib/chain.js